<div class="flex h-full min-h-0 flex-col gap-4 overflow-hidden py-8" *transloco="let t">
  <h4>
    {{ t("common.asins") }}
    <span class="type-body text-muted-foreground">
      ({{ t("common.selected", { count: asins().asins().value().length }) }} / {{ asinsLimit }})
    </span>
  </h4>

  <div class="min-h-0 flex-1">
    <app-asin-selection
      class="block h-full"
      [csvExport]="false"
      [asinsLimit]="asinsLimit"
      [selectedAsins]="asins().asins().value()"
      (selectedAsinsChange)="selectAsins($event)"
    />
  </div>
</div>
